export default function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
      <path
        d="M4.76188 9.52267C6.92784 9.52267 8.69046 7.76005 8.69046 5.5941C8.69046 3.42815 6.92784 1.66553 4.76188 1.66553C2.59593 1.66553 0.833313 3.42815 0.833313 5.5941C0.833313 7.76005 2.59593 9.52267 4.76188 9.52267ZM4.76188 2.97505C6.20629 2.97505 7.38093 4.14969 7.38093 5.5941C7.38093 7.0385 6.20629 8.21315 4.76188 8.21315C3.31748 8.21315 2.14284 7.0385 2.14284 5.5941C2.14284 4.14969 3.31748 2.97505 4.76188 2.97505Z"
        fill="currentColor"
      />
      <path
        d="M18.5114 6.24979C18.8728 6.24979 19.1662 5.95646 19.1662 5.59503C19.1662 5.2336 18.8728 4.94027 18.5114 4.94027H11.309C10.9476 4.94027 10.6543 5.2336 10.6543 5.59503C10.6543 5.95646 10.9476 6.24979 11.309 6.24979H18.5114Z"
        fill="currentColor"
      />
      <path
        d="M15.238 10.8322C13.072 10.8322 11.3094 12.5948 11.3094 14.7608C11.3094 16.9267 13.072 18.6893 15.238 18.6893C17.4039 18.6893 19.1665 16.9267 19.1665 14.7608C19.1665 12.5948 17.4039 10.8322 15.238 10.8322ZM15.238 17.3798C13.7936 17.3798 12.6189 16.2052 12.6189 14.7608C12.6189 13.3164 13.7936 12.1417 15.238 12.1417C16.6824 12.1417 17.857 13.3164 17.857 14.7608C17.857 16.2052 16.6824 17.3798 15.238 17.3798Z"
        fill="currentColor"
      />
      <path
        d="M8.69046 14.1069H1.48807C1.12665 14.1069 0.833313 14.4003 0.833313 14.7617C0.833313 15.1231 1.12665 15.4165 1.48807 15.4165H8.69046C9.05188 15.4165 9.34522 15.1231 9.34522 14.7617C9.34522 14.4003 9.05188 14.1069 8.69046 14.1069Z"
        fill="currentColor"
      />
    </svg>
  );
}
